import { BaseRepository } from './BaseRepository';
import { getDatabase, NexxusDatabase } from './NexxusDatabase';
import type { Ecriture } from '@shared/types/Ecriture';

export class EcritureRepository extends BaseRepository<Ecriture> {
  constructor(db?: NexxusDatabase) {
    super((db ?? getDatabase()).ecritures);
  }
  async findByPeriode(tenant_id: string, periode: string): Promise<Ecriture[]> {
    return this.table.where('[tenant_id+periode]').equals([tenant_id, periode]).toArray();
  }
  async findByCompte(tenant_id: string, compte: string): Promise<Ecriture[]> {
    return this.table.where('[tenant_id+compte]').equals([tenant_id, compte]).toArray();
  }
}
